import request from '@/utils/request';

/**
 * 分页查询AI写作记录
 * @param {Object} params - 查询参数
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页数量
 * @param {number} [params.workId] - 作品ID
 * @param {number} [params.chapterId] - 章节ID
 * @param {number} [params.status] - 执行状态 0-执行中 1-成功 2-失败
 * @param {number} [params.writeType] - 写作类型 1-AI写作 2-AI扩写润色
 * @param {Array} [params.orderByList] - 排序参数列表
 * @returns {Promise} - 返回分页数据
 */
export function getAiWriteRecordPage(params) {
  return request({
    url: '/user/aiWrite/record/page',
    method: 'post',
    data: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      workId: params.workId !== undefined && params.workId !== null ? params.workId : undefined,
      chapterId: params.chapterId !== undefined && params.chapterId !== null ? params.chapterId : undefined,
      status: params.status !== undefined && params.status !== null ? params.status : undefined,
      writeType: params.writeType !== undefined && params.writeType !== null ? params.writeType : undefined,
      orderByList: params.orderByList || undefined
    }
  });
}

/**
 * 查询AI写作记录详情
 * @param {Object} params - 查询参数
 * @param {number} params.recordId - 写作记录ID
 * @returns {Promise} - 返回详情数据
 */
export function getAiWriteRecordDetail(params) {
  return request({
    url: '/user/aiWrite/record/detail',
    method: 'post',
    data: {
      recordId: params.recordId
    }
  });
}

/**
 * 查询AI写作记录详情（通过requestId）
 * @param {Object} params - 查询参数
 * @param {string} params.requestId - 请求ID
 * @returns {Promise} - 返回详情数据
 */
export function getAiWriteRequestDetail(params) {
  return request({
    url: '/user/aiWrite/record/requestDetail',
    method: 'post',
    data: {
      requestId: params.requestId
    }
  });
}

/**
 * 分页查询AI记录历史（通过会话ID）
 * @param {Object} params - 查询参数
 * @param {string} params.conversationId - 会话ID（必填）
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页数量
 * @param {number} [params.workId] - 作品ID
 * @param {number} [params.chapterId] - 章节ID
 * @param {number} [params.status] - 执行状态 0-执行中 1-成功 2-失败
 * @param {number} [params.writeType] - 写作类型 1-AI写作 2-AI扩写润色
 * @param {Array} [params.orderByList] - 排序参数列表
 * @returns {Promise} - 返回分页数据
 */
export function getAiWriteRecordHistory(params) {
  return request({
    url: '/user/aiWrite/record/history',
    method: 'post',
    data: {
      conversationId: params.conversationId,
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      workId: params.workId !== undefined && params.workId !== null ? params.workId : undefined,
      chapterId: params.chapterId !== undefined && params.chapterId !== null ? params.chapterId : undefined,
      status: params.status !== undefined && params.status !== null ? params.status : undefined,
      writeType: params.writeType !== undefined && params.writeType !== null ? params.writeType : undefined,
      orderByList: params.orderByList || undefined
    }
  });
}
